/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

const Root = styled(Box)(({theme}) => ({
  position: 'relative',
  zIndex: 0,
  marginTop: theme.spacing(2.5),
  userSelect: 'none',
}));

export {Root as XAsisRoot};
